@if (impersonating(); as imp) {
  <div class="impersonation-banner" role="status">
    <span class="impersonation-banner__who">A ver como <strong>{{ imp.name || (imp.anf ? 'Farmácia ' + imp.anf : 'outro utilizador') }}</strong>, até às {{ expiresAtTime() }}</span>
    <button type="button" class="impersonation-banner__end" [disabled]="endingImpersonation()" (click)="endImpersonation()">Terminar</button>
  </div>
}
<header [class]="headerClass()" class="header">
  <div class="header-container">
    <!-- Left Section: Logo -->
    <div class="header-left">
      @if (config().showLogo) {
        <div class="header-logo">
          <button
            type="button"
            class="logo-link"
            (click)="onLogoClick()"
            aria-label="Go to dashboard"
          >
            <img src="assets/Ezfy-Logo-w-300.webp" alt="Ezfy Logo" class="logo">
          </button>
        </div>
      }
    </div>

    <!-- Middle Section: Centered Navigation -->
    @if (config().showNavigation) {
      <div class="header-center">
        <nav class="header-navigation" role="navigation">
          <ul class="nav-list">
            @for (item of displayNavigationItems(); track item.path) {
              <li class="nav-item">
                <button
                  type="button"
                  class="nav-link"
                  [class.active]="item.active"
                  [class.disabled]="item.disabled"
                  [disabled]="item.disabled"
                  (click)="onNavigationClick(item)"
                  [attr.aria-label]="item.label"
                >
                  <span class="nav-text">{{ item.label }}</span>
                </button>
              </li>
            }
          </ul>
        </nav>
      </div>
    }

    <!-- Right Section: Actions -->
    <div class="header-right">
      <div class="header-actions">
        <!-- Search Button -->
        @if (config().showSearch) {
          <button
            type="button"
            class="header-action"
            (click)="toggleSearch()"
            aria-label="Search"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8"/>
              <path d="m21 21-4.35-4.35"/>
            </svg>
          </button>
        }

        <!-- Notifications Button -->
        @if (config().showNotifications) {
          <button
            type="button"
            class="header-action"
            aria-label="Notifications"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
            </svg>
          </button>
        }

        @if (showPicker()) {
          <ng-container *ngTemplateOutlet="pharmacyPicker" />
        }

        <!-- The portal's launcher, opened in the same tab (login-farmacias change app-switcher) -->
        @if (config().showUserMenu && switcherUrl(); as apps) {
          <a class="header-action header-apps" [href]="apps" aria-label="Aplicações" title="Aplicações">
            <img src="assets/login-farmacias-mark.svg" width="24" height="24" alt="" aria-hidden="true">
          </a>
        }

        <!-- User Menu -->
        @if (config().showUserMenu && isAuthenticated()) {
          <div class="user-menu-container" #userMenuContainer>
            <button
              type="button"
              class="user-menu-trigger"
              (click)="toggleUserMenu()"
              [attr.aria-expanded]="isUserMenuOpen()"
              aria-label="User menu"
            >
              <div class="user-avatar">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
              </div>
              <span class="user-name">{{ profileName() }}</span>
              <svg
                class="dropdown-icon"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                [class.rotated]="isUserMenuOpen()"
              >
                <polyline points="6,9 12,15 18,9"/>
              </svg>
            </button>

            @if (isUserMenuOpen()) {
              <div class="user-menu-dropdown">
                <ng-container *ngTemplateOutlet="userMenuBody" />
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</header>

<!-- Bottom bar: replaces the header on touch screens and narrow windows (see header.scss) -->
<nav class="bottom-bar" aria-label="Navegação">
  @if (config().showLogo) {
    <button type="button" class="bottom-bar__brand" (click)="onLogoClick()" aria-label="Ezfy">
      <img src="assets/Ezfy-Logo-w-300.webp" alt="Ezfy" class="bottom-bar__logo">
    </button>
  }

  @if (config().showNavigation) {
    <div class="bottom-bar__sections">
      @for (item of displayNavigationItems(); track item.path) {
        <button
          type="button"
          class="bottom-bar__item"
          [class.bottom-bar__item--active]="item.active"
          [attr.aria-current]="item.active ? 'page' : null"
          [disabled]="item.disabled"
          (click)="onNavigationClick(item)"
        >
          <span class="bottom-bar__indicator">
            @if (item.icon) {
              <span class="material-symbols-outlined" aria-hidden="true">{{ item.icon }}</span>
            }
          </span>
          <span class="bottom-bar__label">{{ item.label }}</span>
        </button>
      }
    </div>
  }

  <!-- The portal's launcher, beside the account, as in the header -->
  @if (config().showUserMenu && switcherUrl(); as apps) {
    <a class="bottom-bar__apps" [href]="apps" aria-label="Aplicações" title="Aplicações">
      <img src="assets/login-farmacias-mark.svg" width="24" height="24" alt="" aria-hidden="true">
    </a>
  }

  @if (config().showUserMenu && isAuthenticated()) {
    <button
      type="button"
      class="bottom-bar__account"
      #bottomMenuContainer
      (click)="toggleBarMenu()"
      [attr.aria-expanded]="isBarMenuOpen()"
      [attr.aria-label]="'Conta: ' + profileName()"
    >
      {{ initials() }}
    </button>
  }
</nav>

<!-- Outside the bar so it can sit above Ana's button, which is above the bar -->
@if (config().showUserMenu && isAuthenticated() && isBarMenuOpen()) {
  <div class="user-menu-dropdown bottom-bar__menu" #bottomMenu>
    <ng-container *ngTemplateOutlet="userMenuBody; context: { inBar: true }" />
  </div>
}

<!-- inBar: opened from the bottom bar, where the menu also carries the pharmacy picker -->
<ng-template #pharmacyPicker>
  <label class="pharmacy-picker">
    <select (change)="onPharmacyChange($event)" aria-label="Farmácia em contexto">
      @for (p of pharmacies(); track p.profileId) { <option [value]="p.anf" [selected]="p.anf === currentAnf()">{{ pharmacyLabel(p) }}</option> }
    </select>
  </label>
</ng-template>

<ng-template #userMenuBody let-inBar="inBar">
  <div class="user-menu-header">
    <span class="user-name-full">{{ profileName() }}</span>
    <span class="user-email">{{ currentUser()?.email || 'user@example.com' }}</span>
  </div>
  @if (inBar && showPicker()) {
    <ng-container *ngTemplateOutlet="pharmacyPicker" />
  }
  <div class="user-menu-actions">
    <!-- Perfil and Equipa belong to a pharmacy profile, which an admin-only session does not have. -->
    @if (!adminOnly()) {
    <button
      type="button"
      class="menu-action"
      (click)="onUserMenuAction('profile')"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
        <circle cx="12" cy="7" r="4"/>
      </svg>
      Perfil
    </button>
    <button
      type="button"
      class="menu-action"
      (click)="onUserMenuAction('team')"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
      Equipa
    </button>
    }
    @if (canManageMembers()) {
      <button type="button" class="menu-action" (click)="onUserMenuAction('pharmacy-accounts')">Contas da farmácia</button>
    }
    @if (isAdmin()) {
      <button
        type="button"
        class="menu-action menu-action--admin"
        (click)="onUserMenuAction('admin-users')"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M12 4.354a4 4 0 1 1 0 5.292M15 21H3v-1a6 6 0 0 1 12 0v1zm0 0h6v-1a6 6 0 0 0-9-5.197M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0z"/>
        </svg>
        Utilizadores registados
      </button>
    }
    @if (isAdmin()) {
      <button
        type="button"
        class="menu-action menu-action--admin"
        (click)="onUserMenuAction('farmacia-sync')"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="3" y="4" width="18" height="16" rx="2"/>
          <path d="M12 8v8M8 12h8"/>
        </svg>
        Sincronização de farmácias
      </button>
    }
    @if (isAdmin()) {
      <button
        type="button"
        class="menu-action menu-action--admin"
        (click)="onUserMenuAction('sms-usage')"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
        Mensagens SMS
      </button>
    }
    <button
      type="button"
      class="menu-action"
      (click)="onUserMenuAction('logout')"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
        <polyline points="16,17 21,12 16,7"/>
        <line x1="21" y1="12" x2="9" y2="12"/>
      </svg>
      Terminar Sessão
    </button>
  </div>
</ng-template>
